import { IconButton } from '@wix/design-system';
import { ChevronDownSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import s from './ScrollDownButton.module.scss';
import cs from 'classnames';
import { Theme } from '../../types';

type ScrollDownButtonProps = {
  theme: Theme;
};

export const ScrollDownButton: React.FC<ScrollDownButtonProps> = ({
  theme,
}) => {
  return (
    <div className={s.buttonWrapper}>
      <IconButton
        size="tiny"
        skin={theme === 'dark' ? 'transparent' : 'light'}
        className={cs(s.button, {
          [s.buttonDark]: theme === 'dark',
        })}
      >
        <ChevronDownSmall />
      </IconButton>
    </div>
  );
};
